import ISO6391 from 'iso-639-1';
import { useState } from 'react';
import { Card, Tabs } from '@mantine/core';
import SuperAdminChatBotSettingsLocale from './SuperAdminChatBotSettingsLocale';

const locales = ['en', 'bg'];

const SuperAdminChatBotSettings = () => {
  const [tab, setTab] = useState(locales[0]);

  return (
    <Card withBorder>
      <Card.Section inheritPadding py="sm">
        <Tabs value={tab} onChange={setTab}>
          <Tabs.List>
            {locales.map((locale, index) => (
              <Tabs.Tab key={index} value={locale}>{ISO6391.getName(locale)}</Tabs.Tab>
            ))}
          </Tabs.List>
          {locales.map((locale, index) => (
            <Tabs.Panel key={index} value={locale} pt={0}>
              <SuperAdminChatBotSettingsLocale locale={locale} />
            </Tabs.Panel>
          ))}
        </Tabs>
      </Card.Section>
    </Card>
  );
};

export default SuperAdminChatBotSettings;
